import {
  Calendar,
  ChakraGridItem,
  ChakraSimpleGrid,
  DateFormat,
  EquipUIFireflyV2Theme,
} from '@equip.health/ui';
import { DateTime } from 'luxon';

import TitleAndValue from '~/components/common/TitleAndValue';
import { EMPTY_DATE_FORMAT } from '~/lib/constants/patients.constants';

const { neutral } = EquipUIFireflyV2Theme.colors;
const ViewDiagnosis = ({ diagnosis }: { diagnosis: PatientDiagnosis }) => {
  const { onsetDate, statusLabel, endDate, statusReason } = diagnosis;
  return (
    <>
      <ChakraSimpleGrid
        gap={6}
        marginBottom="20px"
        marginTop="10px"
        templateColumns="repeat(3, 1fr)"
      >
        <ChakraGridItem>
          <TitleAndValue
            fontSize="14px"
            icon={
              <Calendar fill={neutral.secondary} height="20px" width="20px" />
            }
            marginLeft="10px"
            marginTop="10px"
            title="Onset"
            value={
              onsetDate
                ? DateTime.fromFormat(
                    onsetDate,
                    DateFormat.shortYearMonthDay,
                  ).toFormat(DateFormat.longDate)
                : EMPTY_DATE_FORMAT
            }
          />
        </ChakraGridItem>
        <ChakraGridItem>
          <TitleAndValue
            fontSize="14px"
            marginTop="10px"
            title="Current state"
            value={statusLabel || '-'}
          />
        </ChakraGridItem>
        <ChakraGridItem>
          <TitleAndValue
            fontSize="14px"
            icon={
              <Calendar fill={neutral.secondary} height="20px" width="20px" />
            }
            marginLeft="10px"
            marginTop="10px"
            title="End date"
            value={
              endDate
                ? DateTime.fromFormat(
                    endDate,
                    DateFormat.shortYearMonthDay,
                  ).toFormat(DateFormat.longDate)
                : EMPTY_DATE_FORMAT
            }
          />
        </ChakraGridItem>
      </ChakraSimpleGrid>
      <TitleAndValue
        fontSize="14px"
        marginTop="10px"
        title="Status reason"
        value={statusReason || '-'}
      />
    </>
  );
};

export default ViewDiagnosis;
